import api from "../../services/api/api";

export const servicesRequest = {
  getRequest: async (page: number = 1) => {
    return await api.get(`/pointChange?page=${page}`);
  },
};
